export function StatCard({ label, value, icon: Icon, testid, accent = "text-blue-600 bg-blue-50" }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 shadow-[0_2px_10px_-3px_rgba(15,23,42,0.06)] p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-medium text-slate-500 uppercase tracking-wider truncate">{label}</p>
          <p data-testid={testid} className="text-xl sm:text-2xl font-bold text-slate-900 mt-1 font-heading truncate">{value}</p>
        </div>
        {Icon && (
          <div className={`shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${accent}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}
